import { Column, RowData } from '@tanstack/react-table';
import { FunctionComponent } from 'react';

import { CheckboxGroup } from '@/components/form-elements/CheckboxGroup';

type CheckboxFilterProps<T extends string, TData extends RowData, TValue = unknown> = {
  label: string;
  options: T[];
  column?: Column<TData, TValue>;
  optionLabel: FunctionComponent<{ option: T }>;
};

export function CheckboxFilter<T extends string, TData extends RowData, TValue = unknown>({
  label,
  options,
  column,
  optionLabel,
}: CheckboxFilterProps<T, TData, TValue>) {
  const filterValue = column?.getFilterValue() as T[] | undefined;
  const value = filterValue && filterValue.length > 0 ? filterValue : options;

  return (
    <CheckboxGroup
      label={label}
      options={options}
      values={options.reduce((values, item) => ({ ...values, [item]: value.includes(item) }), {} as Record<T, boolean>)}
      optionLabel={optionLabel}
      onChange={(option) => {
        if (value.includes(option)) {
          column?.setFilterValue(value.filter((item) => item !== option));
        } else {
          column?.setFilterValue([...value, option]);
        }
      }}
      orientation="horizontal"
    />
  );
}
